import './embedded_iframe_section.less';

import React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';

import Iframe from 'zoomforth_component_lib/iframe.jsx';
import { ConditionalSkipLinkForElement } from 'zoomforth_codesbane_viewer/component_lib/skip_link_for_element.jsx';
import { getPreviewCollaborationSettings } from 'zoomforth_codesbane_viewer/reducers/index.js';
import SiteViewerVersionComponentSelector from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';

/*************************************************************************************************/
/*** PROPS ***************************************************************************************/
/*************************************************************************************************/

const PROP_TYPES = {};

const mapStateToProps = (reduxState) => {
  const previewCollaborationSettings = getPreviewCollaborationSettings(reduxState);
  const isPreviewCollaborationEnabled = !!previewCollaborationSettings.isEnabled;

  const iframeWrapperProps = {};
  if(isPreviewCollaborationEnabled){
    iframeWrapperProps['data-velt-iframe-container'] = true;
  }
  
  return {
    iframeWrapperProps
  };
};

const mapDispatchToProps = () => { return {}; };

/*************************************************************************************************/
/*** LEGACY **************************************************************************************/
/*************************************************************************************************/

// bringToFore makes the iframe positioned absolutely with a high z-index,
// so its scrolling can take precedence. 
// The main case is dealing with the emphasizer in the editor

const EmbeddedIframeSection_ViewerVersion1 = ({
  tellRef,
  uuid,
  height,
  iframeSrc,
  iframeTitle,
  bringToFore,
  children,
  iframeWrapperProps
})=> (
  <div className="section-iframe-wrapper" style={{ height }} {...iframeWrapperProps}>

    { children }

    <Iframe
      tellRef={tellRef}
      className={classNames('inline-embed-iframe', {
        'bring-to-foreground': bringToFore,
        [`content-uuid-${uuid}`]: uuid
      })}
      src={iframeSrc}
      title={iframeTitle}
      frameBorder="0"
      allowFullScreen={true} 
    />

  </div>
);

const EmbeddedIframeSection_ViewerVersion2 = ({
  tellRef,
  uuid,
  height,
  iframeSrc,
  iframeTitle,
  bringToFore,
  shouldShowSkipLink,
  children,
  iframeWrapperProps
})=> (
  <div className="section-iframe-wrapper" style={{ height }} {...iframeWrapperProps}>

    { children }

    <ConditionalSkipLinkForElement
      skipLinkText="Skip iframe"
      shouldShowSkipLink={shouldShowSkipLink}
    >
      <Iframe
        tellRef={tellRef}
        className={classNames('inline-embed-iframe', {
          'bring-to-foreground': bringToFore,
          [`content-uuid-${uuid}`]: uuid
        })}
        src={iframeSrc}
        title={iframeTitle}
        frameBorder="0"
        allowFullScreen={true}
      />
    </ConditionalSkipLinkForElement>

  </div>
);

const EmbeddedIframeSection = (props)=> (
  <SiteViewerVersionComponentSelector>
    <EmbeddedIframeSection_ViewerVersion1 forSiteViewerVersion={1} { ...props } />
    <EmbeddedIframeSection_ViewerVersion2 forSiteViewerVersion={2} { ...props } />
  </SiteViewerVersionComponentSelector>
);

EmbeddedIframeSection.propTypes = PROP_TYPES;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmbeddedIframeSection);
